import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import { FileComponent } from '../../../../components/FileComponent';
import * as generic from '../../../../components/Generico';
import { OrigenDeclaracion as OrigenDeclaracionModel } from '../../../../models/ficha/OrigenDeclaracion';
import { OrigenService } from '../../../../service/OrigenService';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';

export const Declaracion = ({ toast, id, permss, catalogos, handlePrev, mostrarAnexos, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new OrigenDeclaracionModel();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });
    const origenService = new OrigenService();
    const { inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = FileComponent({ tipo: 'origen', toast, unuevo: 'ficha/origen/store', udelete: 'ficha/origen/eliminar-anexo', permss, id });
    const esToyota = catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA';
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [tipoPersona, setTipoPersona] = useState(null);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        origenService.consultarOrigen(id, 'seccion3').then(res => {
            const _origen = res.data.origen;

            if (!_origen) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            setTipoPersona(_origen.tipo_persona);
            reset(generic.renewValues(_origen, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion3';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        data.tipoPersona = tipoPersona;

        origenService.editarOrigen(data).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const generarReporte = () => {
        setLoadReport(true);
        origenService.descargar(id, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            generic.downloadPdf(res, `${id}-Formulario-Origen-Licito.pdf`);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const enviar = () => {
        enviarFormulario(id, 'ficha/origen/enviar?tipoFrmEmpresa=' + (catalogos?.tipoFrmEmpresa ?? ''), 'origen');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form id="formulario-declaraciones" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('6', 'DECLARACIÓN DE ORIGEN LÍCITO DE RECURSOS', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('entrega', generic.estadosSiNo, { lab: 'nombre' }, 12)}
                    {inDrop('recepcion', generic.estadosSiNo, { lab: 'nombre' }, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('', 'DECLARACIÓN', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 m-2">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-verified text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Términos de la Declaración</span>
                    </div>
                    {omodel.strDeclaracion}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 m-2">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-shield text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                    </div>
                    {!esTipoEspecial && omodel.strAutorizacionTratamientoDatos}
                    {esToyota && omodel.strToyota}
                    {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                </div>
            </Panel>

            {esToyota && tipoPersona === 'NATURAL' &&
                <Panel header={generic.renderPanelHeader('', 'CONSENTIMIENTO PARA EL USO DE DATOS PERSONALES', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        <div className="col-12 mb-2">
                            <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                                {omodel.strConceder}
                            </div>
                        </div>
                        {inDrop('uso_dato_personal', generic.estadosSiNo, { lab: 'nombre' }, 4)}

                        <div className="col-8">
                            <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 h-full">
                                {omodel.strActividad}
                            </div>
                        </div>
                    </div>
                </Panel>
            }

            <BottomActionBar formId="formulario-declaraciones" onPrev={handlePrev} onSave={true} onGenerate={generarReporte} onSend={enviar} onAttachments={mostrarAnexos}
                loading={isSaving || loadReport} isReadOnly={soloLectura} enableExtras={id != null} />
        </form>
    );
}
